export default {
  connectToDataSource: 'Connect to data source',
  noDataSourceFound: 'This asset is not connected to any supported SCADA system or controller.',
};
